import { boolean, object, string } from "yup";
import { testEmail } from "../../utils/FormValidationsUtils";

export const addressSchema = (fromCreateForm: boolean) =>
  object().shape({
    id: fromCreateForm ? string().optional() : string().required(),
    organization: string().required(),
    firstName: string().required(),
    lastName: string().required(),
    address: string().required(),
    appartment: string(),
    city: string().required(),
    country: string().required(),
    state: string().required(),
    zipcode: string().required(),
    phone: string().required(),
    email: string().required().test(testEmail),
  });

export const CartSchema = (fromCreateForm: boolean = false) =>
  object().shape({
    shippingAddress: addressSchema(fromCreateForm),
    billingAddress: object()
      .shape({
        id: string().optional(),
      })
      .test(
        "billing-address-required",
        "Billing address is required",
        (value) => {
          if (value.id === "default" || value.id === "default-shipping") {
            return true;
          } else {
            return addressSchema(fromCreateForm).isValidSync(value);
          }
        }
      ),
    termsAndConditionsAccepted: boolean()
      .required()
      .oneOf([true], "The terms and conditions must be accepted"),
    finalDesignValidated: boolean()
      .required()
      .oneOf([true], "The final design must be validated"),
  });
